import { useQuery } from "@tanstack/react-query";
import { loadSpaceAccessibilityTagsPublic } from "../../apis";

export function useLoadSpaceAccessibilityTagsPublic({
  businessId,
  googleBusinessId,
  reviewId,
  reviewLevelId,
  enabled,
}: {
  businessId: string;
  googleBusinessId: string;
  reviewId: string;
  reviewLevelId: string;
  enabled: boolean;
}) {
  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: [
      "loadSpaceAccessibilityTagsPublic",
      businessId,
      reviewId,
      reviewLevelId,
    ],
    queryFn: async () => {
      const data = await loadSpaceAccessibilityTagsPublic(
        businessId,
        googleBusinessId,
        reviewId,
        reviewLevelId
      );
      return data;
    },
    enabled,
  });
  
  return {
    data,
    error,
    isLoading: isLoading || isFetching,
    refetch,
  };
}
